import React, { useState, useEffect } from 'react';

import * as Form from 'components/form';
import * as Page from 'components/page';
// import * as Alert from 'components/alert';

import { CorporationCard } from '../components';

export function EcosystemStep3EditForm(props) {
    const [isEmailValid, setIsEmailValid] = useState(false);
    // const [renderWarning, setRenderWarning] = useState(false);
    const { form, onSubmit } = props;

    // Create form fields object
    const fields = {
        companyContactName: {
            error: form.errors.companyContactName,
            label: props.t('companyContactName'),
            name: 'companyContactName',
            type: 'text',
            value: form.values.company.contact.name,
            onChange: form.handleChange,
            disabled: form.values.isConfirmed,
        },
        companyContactEmail: {
            error: form.errors.ecosystemContactEmail,
            label: props.t('companyContactEmail'),
            name: 'companyContactEmail',
            type: 'email',
            value: form.values.company.contact.email,
            onChange: form.handleChange,
            disabled: form.values.isConfirmed,
        },
        companyConfirmationEmail: {
            error: form.errors.companyConfirmationEmail,
            label: props.t('companyContactEmail2'),
            name: 'companyConfirmationEmail',
            type: 'email',
            value: form.values.company.contact.email,
            onChange: form.handleChange,
            disabled: form.values.isConfirmed,
        },
        companyName: {
            error: form.errors.companyName,
            label: props.t('ecossystemCompanyName'),
            name: 'companyName',
            type: 'text',
            value: form.values.companyName,
            onChange: form.handleChange,
            disabled: form.values.isConfirmed,
        },
        programName: {
            error: form.errors.programName,
            label: props.t('glossary:programName'),
            name: 'programName',
            type: 'text',
            value: form.values.programName,
            onChange: form.handleChange,
        },
        description: {
            error: form.errors.description,
            label: props.t('glossary:description'),
            name: 'description',
            required: false,
            type: 'textarea',
            value: form.values.description,
            onChange: form.handleChange,
        },
        year: {
            displayFormat: 'YYYY',
            error: form.errors.year,
            label: props.t('glossary:year'),
            maxLength: 4,
            name: 'year',
            type: 'text',
            value: form.values.year,
            onChange: form.handleChange,
            disabled: form.values.isConfirmed,
        },
        linkUrl: {
            error: form.errors.linkUrl,
            label: props.t('glossary:linkUrl'),
            name: 'linkUrl',
            type: 'text',
            required: false,
            value: form.values.linkUrl,
            onChange: form.handleChange,
        },
    };
    const companyContactEmail = fields.companyContactEmail.value;
    const companyConfirmationEmail = fields.companyConfirmationEmail.value;

    useEffect(() => {
        setIsEmailValid(companyConfirmationEmail === companyContactEmail);
    }, [isEmailValid, companyContactEmail, companyConfirmationEmail]);
    // const propsAlert = {
    //     descr: props.t('glossary:emailConfirmationError'),
    //     icons: 'far fa-exclamation-circle',
    //     type: 'warning',
    //     color: 'red',
    // };

    // Handle form submition
    const evSubmit = ev => form.handleSubmit(ev, onSubmit);
    return (
        <Form.Form name="EcosystemStep3Edit" onSubmit={evSubmit}>
            <Page.Boxed>
                <CorporationCard {...form.values} />
                <Page.Discl>{props.t('EcosystemStep3Edit.noChangeToCorporation')}</Page.Discl>
            </Page.Boxed>

            <Form.Field {...fields.companyContactName} />
            <Form.Field {...fields.companyContactEmail} />
            <Form.Field {...fields.companyConfirmationEmail} />
            {/* {renderWarning && <Alert.AlertRow {...propsAlert} />} */}

            <Page.Ruler />

            <Form.Field {...fields.companyName} />
            <Form.Field {...fields.programName} />
            <Form.Row>
                <Form.Field size="4" {...fields.year} />
                <Form.Field size="8" {...fields.linkUrl} />
            </Form.Row>
            <Form.Field {...fields.description} />

            <Form.Submt {...form} text={props.t('glossary:save')} />
        </Form.Form>
    );
}
export default EcosystemStep3EditForm;
